import React, { useState } from "react"
import FileViewerByFileUrl from "components/FileViewerByFileUrl"
import { Box, Button, Tab } from "@mui/material"
import PanoViewerLayer from "components/layer/PanoViewerLayer"
import EquipmentImgFileModifyLayer from "components/layer/EquipmentImgFileModifyLayer"
import FileDownloadIcon from "components/FileDownloadIcon"
import { useTranslation } from "react-i18next"
import useConfig from "hooks/useConfig"
import { useQuery } from "@tanstack/react-query"
import { getFileManagersByQuery } from "components/axios/fileManagerAxios"
import { TabContext, TabList, TabPanel } from "@mui/lab"
import EquipmentDataTab from "./data/dataTab"
import MainCard from "components/MainCard"

const PictureTab = ({info, previewImage, extension, selectedStream, selectedImgId, onRefresh, setDefaultImageFromFile, setImageFromFile}) => {
    const { t } = useTranslation();
    const { mode } = useConfig();

    let dataParam = {
        page : 0,
        size : 1,
        fileManagerType : "C"
    };
    dataParam["equipmentCtgr.parent.id"] = info.equipmentCtgr.parent.parent.id;
    dataParam["equipmentCtgr.id"] = info.equipmentCtgr.parent.id;
    
    const { data: dataCheckData, isFetched: isDataChecked } = useQuery({
        queryKey: ['datas', 'check', info.equipmentCtgr.parent.parent.id, info.equipmentCtgr.parent.id],
        queryFn: () => getFileManagersByQuery(dataParam),
        enabled: !!info.equipmentCtgr.parent.parent.id && !!info.equipmentCtgr.parent.id,
    });
    const hasData    = (dataCheckData?.page?.totalElements ?? 0) > 0;
    
    const [pnTab, setPnTab] = useState('0');
    const selectPanel = (event, newValue) => {
        setPnTab(newValue);
    };

    return (
        <div className='alert_phrase'>
            <Box sx={{ width: '100%', typography: 'body1' }} className="control_panel control_panel1">
                <TabContext value={pnTab}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList onChange={selectPanel}>
                            <Tab className="graphTab" label={t('message.common.tabTitle.picture.floor.plan')} value="0" style={{ display: "inline-block", padding: "6px 15px", margin: "0 5px 7px 0px", borderRadius: "100px", border: `${pnTab === "0" ? "3px solid #0061d0" : "1px solid #0061d0"}` }} />
                            {hasData && <Tab className="graphTab" label={t('message.common.chip.reference.data')} value="1" style={{ display: "inline-block", padding: "6px 15px", margin: "0 5px 7px 0px", borderRadius: "100px", border: `${pnTab === "1" ? "3px solid #0061d0" : "1px solid #0061d0"}` }} />}
                        </TabList>
                    </Box>
                    <MainCard className="center_table" content={false}>
                        <TabPanel value="0">
                            <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginTop:"10px", width:"100%"}}>
                                <div className="vr_btn_box">
                                    <div>
                                    {info?.imgFiles && info.imgFiles.length > 0 ?
                                    <div className="vr_btn">
                                        {info.imgFiles.map((img, i)=>{
                                        return (
                                        <Button key={img.id} variant="contained" style={{minWidth:"unset",color:"#fff", marginRight:"4px" ,padding:"3px 10px"}} className={img.id === selectedImgId ? ' on' : ''} color="primary" onClick={()=>setImageFromFile(img, i+1)}>
                                            <span className="icon_png"><img style={{width:"20px"}} src={`${process.env.PUBLIC_URL}/img/icon/construction.png`} alt='' /></span>&nbsp;{t('message.common.btn.equipment')}{i+1}
                                        </Button>
                                        )
                                        })}
                                    </div>
                                    :
                                    <div className="vr_btn">
                                        <Button variant="contained" style={{minWidth:"unset",color:"#fff", marginRight:"4px" ,padding:"3px 10px"}} color="primary" onClick={()=>setDefaultImageFromFile(1)}>
                                            <span className="icon_png"><img style={{width:"20px"}} src={`${process.env.PUBLIC_URL}/img/icon/construction.png`} alt='' /></span>&nbsp;{t('message.common.btn.equipment')}
                                        </Button>
                                    </div>
                                    }
                                    {info && info.bpFile &&
                                    <div className="vr_btn">
                                        <Button key={info.bpFile.id} variant="contained" style={{minWidth:"unset",color:"#fff", marginRight:"4px" ,padding:"3px 10px"}} className={info.bpFile.id === selectedImgId ? ' on' : ''} color="primary" onClick={()=>setImageFromFile(info.bpFile, info.imgFiles.length+1)}>
                                            <span className="icon_png"><img style={{width:"20px"}} src={`${process.env.PUBLIC_URL}/img/icon/history_edu.png`} alt='' /></span>&nbsp;{t('message.common.btn.floor.plan')}
                                        </Button>
                                    </div>
                                    }
                                    </div>

                                    <div>
                                    {info && info.vrFiles && info.vrFiles.map(function(item, i) {
                                        return (
                                    <div key={i}><PanoViewerLayer info={info} idx={i+1} /></div>
                                        )
                                    })}
                                    </div>
                                </div>
                                <div style={{display:"flex"}}>
                                    {/* <CCTVButtons selectedStream={selectedStream} onSelect={setSelectedStream} initDefaultImage={initDefaultImage} /> */}
                                    {/* <div className="vr_btn">
                                        <Button variant="contained" style={{minWidth:"unset",color:"#fff", marginRight:"4px" ,padding:"3px 10px"}} className={selectedBp} color="primary" onClick={()=>setCCTV("stream1")}>
                                        &nbsp;CCTV stream1 Viewer
                                        </Button>
                                        <Button variant="contained" style={{minWidth:"unset",color:"#fff", marginRight:"4px" ,padding:"3px 10px"}} className={selectedBp} color="primary" onClick={()=>setCCTV("stream2")}>
                                        &nbsp;CCTV stream2 Viewer
                                        </Button>
                                    </div> */}
                                    {/* <CCTVWebRTCLayer stream='stream1'/><CCTVWebRTCLayer stream='stream2'/> */}
                                    <EquipmentImgFileModifyLayer equipmentId={info && info.id} onRefresh={onRefresh} />
                                </div>
                            </div>
                            
                            {(previewImage || extension || selectedStream) && 
                            <div style={{marginTop:"5px", width:"85%", minHeight: "470px"}}>
                                <FileViewerByFileUrl fileUrl={previewImage} extension={extension}
                                    sampleImgSrc={(mode === 'light' ? process.env.PUBLIC_URL+"/img/sample1.png" : process.env.PUBLIC_URL+"/img/sample.png")}
                                    selectedStream={selectedStream}
                                />
                            </div>
                            }

                            <div>
                                <div>
                                    {info && info.files && info.files.map(function(item, i) {
                                        return (
                                    <div key={i} style={{width:"100%"}}><FileDownloadIcon file={item} viewFileName={true} iconSize="small" /></div>
                                        )
                                    })}
                                </div>
                            </div>
                        </TabPanel>

                        {hasData &&
                        <TabPanel value="1">
                            <EquipmentDataTab info={info} />
                        </TabPanel>
                        }
                    </MainCard>
                </TabContext>
            </Box>
        </div>
    )
}

export default PictureTab;